import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Typography,
    TextField,
    InputAdornment,
    Grid,
    Card,
    CardActionArea,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { styled, keyframes } from '@mui/system';
import HomeIcon from '@mui/icons-material/Home';
import ScrollToTopButton from '../../Button/ScrollToTopButton';
// import FloatingMenu from "../../Button/FloatingButton"; // Removed unused import
import axios from 'axios';

const slideInFromLeft = keyframes`
    0% {
        transform: translateX(-20px);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));

const names = [
    "All Invoice", "Return Invoice", "Expenses", "Inventory", "Investment", "Summary",
    "Profit & Loss", "Customers", "Sales by customer summary", "Sales by product summary", "Outstanding", "Bank Account History"
];

const links = [
    "/report-invoice", "/report-return-invoice", "/report-expenses", "/report-inventory", "/report-investment", "/report-summary",
    "/report-profit-loss", "/report-customers", "/report-sales-customer", "/report-sales-product", "/report-outstanding", "/bank-account-history"
];

const AllReport = () => {
    const [user, setUser] = useState({});
    const [search, setSearch] = useState("");
    const navigate = useNavigate();
    const [userSubscription, setUserSubscription] = useState(null);

    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/"); // Redirect if no token
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/"); // Redirect on 401 error
                }
            }
        };

        fetchProfile();
    }, [navigate]);

    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");
    
                const matchedSub = response.data.subscription
                    .filter(sub => sub.email === user.email && sub.status === "active")
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
    
                setUserSubscription(matchedSub || null);
            } catch (error) {
                console.error("Failed to fetch subscriptions", error);
            }
        };
    
        if (user?.email) {
            fetchSubscriptions();
        }
    }, [user?.email]);
    

    const filteredNames = names.filter(name =>
        name.toLowerCase().includes(search.toLowerCase())
    );

    const getPlan = () => {
        return userSubscription?.plan || "N/A";
    };

    const canAccessReport = (index) => {
        const plan = getPlan();
        const reportName = names[index];

        if (plan === "premium") {
            return true;
        }
        if (plan === "basic" && (reportName === "All Invoice" || reportName === "Expenses" || reportName === "Inventory" || reportName === "Investment" || reportName === "Profit & Loss")) {
            return true;
        }
        if (plan === "free" && reportName === "All Invoice") {
            return true;
        }
        if (plan === "30 days free") {
            return true;
        }
        if (plan === "N/A" && reportName === "") {
            return true;
        }
        return false;
    };

    const handleCardClick = (index) => {
        if (canAccessReport(index)) {
            navigate(links[index]);
        } else {
            // Optionally provide feedback to the user, e.g., a tooltip or a message
            console.log(`Access to ${names[index]} is not allowed for your current plan.`);
        }
    };

    return (
        <Box
        sx={{mt:10}}
        >
            <AnimatedTypography
                component="h1"
                sx={{
                    ml: { xs: 2, sm: 3 },
                    mt: { xs: 2, sm: 3 },
                    color: 'secondary.main',
                    letterSpacing: '0.01em',
                    fontSize: { xs: '20px', sm: '24px' },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center',ml:1 }}>
                    {/**<Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' },
                            fontSize: { xs: '14px', sm: '20px' },
                            fontWeight: 'bold',
                        }}
                    >
                        Reports
                    </Typography>
                    <Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' },
                            ml: 1,
                            fontSize: '14px',
                        }}
                    >
                        |
                    </Typography>*/}
                    <HomeIcon sx={{ ml: 1, fontSize: '18px', color: '#6d7081' }} />
                    <Typography
                        component="span"
                        sx={{
                            ml: 0.5,
                            fontSize: '14px',
                            color: '#6d7081',
                        }}
                    >
                        - Reports
                    </Typography>
                </Box>
            </AnimatedTypography>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: {sm:'95%',xs:'90%'},
                    maxWidth: 'auto',
                    margin: 'auto',
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',                    
                    marginTop: '30px',
                    position: 'relative',
                    mb: { xs: 15, sm: 5 },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', color: '#1e293b',ml:2 }}>
                    <h2>Reports</h2>
                </Box>

                {/* Search Box */}
                <TextField
                    variant="outlined"
                    placeholder="Search Report"
                    size="small"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon  />
                            </InputAdornment>
                        )
                    }}
                    sx={{
                        mb: 3,
                        ml:2,
                        width: '245px',
                        borderRadius: '8px',
                        bgcolor: 'rgba(240, 240, 240, 0.17)',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            bgcolor: 'rgba(240, 240, 240, 0.17)',
                        },
                    }}
                />

                <Grid container spacing={2} p={3}>
                    {filteredNames.map((name) => {
                        const originalIndex = names.indexOf(name);
                        return (
                            <Grid item xs={12} sm={6} key={originalIndex}>
                                <Card
                                    sx={{
                                        textAlign: "center",
                                        position: "relative",
                                        color: 'black',
                                        boxShadow: "none",
                                        border: "1px solid rgba(0, 0, 0, 0.16)",
                                        transition: "background-color 0.3s ease",
                                        "&:hover": {
                                            bgcolor: canAccessReport(originalIndex) ? "#f1f5f9" : undefined,
                                            cursor: canAccessReport(originalIndex) ? "pointer" : "not-allowed",
                                        },
                                        opacity: canAccessReport(originalIndex) ? 1 : 0.6, 
                                    }}
                                >
                                    <CardActionArea
                                        onClick={() => handleCardClick(originalIndex)}
                                        disabled={!canAccessReport(originalIndex)}
                                        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 1.5 }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <ArrowForwardIosIcon sx={{ fontSize: "inherit" }} />
                                            <Typography variant="body2" color="textPrimary" sx={{ fontSize: "15px" }}>{name}</Typography>
                                        </Box>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
            <ScrollToTopButton />
        </Box>
    );
};

export default AllReport;